import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface MessageInputProps {
  message: string;
  isLoading: boolean;
  onMessageChange: (message: string) => void;
  onSendMessage: () => void;
}

export function MessageInput({
  message,
  isLoading,
  onMessageChange,
  onSendMessage,
}: MessageInputProps) {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !isLoading) {
      e.preventDefault();
      onSendMessage();
    }
  };

  const handleSendClick = () => {
    if (!isLoading && message.trim()) {
      onSendMessage();
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Type your message..."
        disabled={isLoading}
      />
      <Button 
        onClick={handleSendClick}
        disabled={isLoading || !message.trim()}
      >
        {isLoading ? <Loader2 className="animate-spin" /> : "Send"}
      </Button>
    </div>
  );
}